<template>
    <div>    
                 
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import db from '@/db';

export default {

    name: "Recipe",
    data() {
        return {
            id: this.$route.params.id,
        }
    },
    async mounted() {
        await this.init();
        db.collection('recipes').doc(this.id)
                .get().then(docSnapshot => {
                    if (!docSnapshot.exists) {
                    this.$router.push({ name: 'Home' })
                    }
                    else {
                    this.$router.push({ path: `/recipe/${this.recipe.id}/${this.recipe.slug}` })
                    }
                });
    },
    computed: {
        ...mapState('recipe', ['recipe', 'user_meals', 'menus']),
    },
    methods: {
        
        ...mapActions('recipe', ['init']),
    }
}
</script>
